// contains all variables that should be constant and be reused in the project
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = 'bb41e04b-b46a-43da-b616-a953679bd53f';

export const MODAL_CLOSE_SEC = 2.5;
